import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { redirect } from 'redux-first-router'

import {
  doRemoveIntegration,
  doUpdateIntegrationProviderSettings,
  selectDidError,
  selectIntegrationSettingsForId,
} from 'ducks/integrations'
import { selectMailboxesIncludingInaccessible } from 'selectors/mailboxes'
import { selectPropertiesByType } from 'ducks/integrations/salesforce/selectors'
import doFetchBatchProperties from 'ducks/integrations/salesforce/operations/doFetchBatchProperties'

import { SETTINGS_INTEGRATIONS_PAGE } from '../../../../types'
import SettingsModal from './SettingsModal'
import InstallModal from './InstallModal'

function select(state, initialOwnProps) {
  const { id } = initialOwnProps
  return {
    initialValues: selectIntegrationSettingsForId(state, id),
    mailboxes: selectMailboxesIncludingInaccessible(state),
    error: selectDidError(state),
    contactProperties: selectPropertiesByType(state, 'Contact'),
    opportunityProperties: selectPropertiesByType(state, 'Opportunity'),
    leadProperties: selectPropertiesByType(state, 'Lead'),
    accountProperties: selectPropertiesByType(state, 'Account'),
    taskProperties: selectPropertiesByType(state, 'Task'),
  }
}

const perform = (dispatch, { id }) => {
  function doCloseModal() {
    dispatch(redirect({ type: SETTINGS_INTEGRATIONS_PAGE }))
  }
  return {
    doFetchProperties: () => {
      dispatch(
        doFetchBatchProperties([
          'Contact',
          'Lead',
          'Account',
          'Opportunity',
          'Task',
        ])
      )
    },
    doCloseModal,
    doUpdateIntegrationProviderSettings: (provider, values) =>
      dispatch(doUpdateIntegrationProviderSettings(provider, values)),
    doRemoveIntegration: () => {
      doCloseModal()
      dispatch(doRemoveIntegration(id))
    },
  }
}

class Modal extends PureComponent {
  render = () => {
    const {
      props,
      props: { id },
    } = this
    if (id) return <SettingsModal {...props} />

    return <InstallModal {...props} />
  }
}
export default connect(select, perform)(Modal)
